import AnalyticsWebClient, { envType, originType } from '@atlassiansox/analytics-web-client';
import { payloadPublisher, ufologger, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { DEVELOPMENT, Environment, LOCAL, PRODUCTION, STAGING } from '@atlassian/temp-shared';
import { version } from 'react';

const ANALYTICS_PRODUCT_PPC = 'partnerPurchasingCenter';

// publisher setup for ufo to track the experience (events)
export const initUFO = () => {
  const env = getEnvType();

  if (env !== envType.PROD && env !== envType.STAGING) {
    ufologger.enable();
  }

  const apiHost =
    getEnvironment() === envType.PROD
      ? 'api-private.atlassian.com/gasv3/api/v1'
      : 'api-private.stg.atlassian.com/gasv3/api/v1';

  const analyticsClient = new AnalyticsWebClient(
    {
      env,
      origin: originType.WEB,
      product: ANALYTICS_PRODUCT_PPC,
    },
    { apiHost }
  );

  // TODO: COMMIT-7497 Find org and workspace ID
  // analyticsClient.setOrgInfo('dummy-fc0877ef-3ffd-4a22-81b9-68b6884e6a96');
  // analyticsClient.setWorkspaceInfo('workspaceAri / workspaceID');

  payloadPublisher.setup({
    gasv3: analyticsClient,
    product: ANALYTICS_PRODUCT_PPC,
    app: {
      version: { web: '0.1.0' }, // your web application version
      framework: {
        name: 'react',
        version,
      },
    },
    performanceConfig: {
      histogram: {
        [ExperiencePerformanceTypes.PageLoad]: {
          initial: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '4000_4500_5000_6000_7000_8000_9000',
          },
          transition: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '2500_3000_3500_4000_5000_6000',
          },
        },
        [ExperiencePerformanceTypes.PageSegmentLoad]: {
          initial: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '4000_4500_5000_6000_7000_8000_9000',
          },
          transition: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '2500_3000_3500_4000_5000_6000',
          },
        },
      },
    },
  });
};

const getEnvironment: () => Environment = () => {
  const hostName = window.location.hostname;
  if (hostName.includes('.dev.')) {
    return DEVELOPMENT as Environment;
  } else if (hostName.includes('.staging.')) {
    return STAGING as Environment;
  } else if (hostName.includes('ppc.atlassian') || hostName.includes('.prod.')) {
    // ppc hostname will not have .prod. in the string when accessed from our public DNS name
    return PRODUCTION as Environment;
  } else if (hostName.includes('localhost')) {
    return LOCAL as Environment;
  } else {
    return STAGING as Environment;
  }
};

const getEnvType = () => {
  switch (getEnvironment()) {
    case LOCAL:
      return envType.LOCAL;
    case DEVELOPMENT:
      return envType.DEV;
    case STAGING:
      return envType.STAGING;
    case PRODUCTION:
      return envType.PROD;
    default:
      return envType.STAGING;
  }
};
